module.exports = "/fonts/fa-brands-400.woff?fe9d62e0d16a333a20e63c3e7595f82e";